import React from "react";
export const PlayerDevice = ({ layoutItem }) => {
    return React.createElement(React.Fragment, null);
};
